import './riverside/style';
import FormStructure from './riverside/form_structure';

export default FormStructure;